export enum ResearchTeamMemberAccountStatusEnum {
    NoAccount = 'NoAccount',
    Disabled = 'Disabled',
    Enabled = 'Enabled',
}
